
import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { PaginatorModel, HasPagination } from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';
import { UnidadNegocio } from '@/app/models/interface/unidad-negocio.model';

@Injectable({ providedIn: 'root' })
export class UnidadService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'unidad-negocio/';

  create(data: Partial<UnidadNegocio>) {
    return this.http.post<CustomResponse<UnidadNegocio>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<UnidadNegocio[], HasPagination>>>(
        this.url,
        {
          params,
        },
      )
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<UnidadNegocio>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<UnidadNegocio>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<UnidadNegocio>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<UnidadNegocio>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }
}
